import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Modal from "../../../common/components/Modal";
import './ViewDetailsButton.module.css';
import styles from './ViewDetailsButton.module.css';
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

function ViewDetailsButton(data) {
  const reshape = (data) => {
    const oldData = data.data.oldData ? JSON.parse(data.data.oldData) : {};
    const newData = data.data.newData ? JSON.parse(data.data.newData) : {};
    const keysList = [];
    const keySet = new Set();
    Object.keys(oldData).forEach((p) => {
      if (!keySet.has(p)) {
        keysList.push(p);
        keySet.add(p)
      }
    });
    Object.keys(newData).forEach((p) => {
      if (!keySet.has(p)) {
        keysList.push(p);
        keySet.add(p)
      }
    });
    return keysList.map((key) => ({
      key,
      oldData: oldData[key]?.toString(),
      newData: newData[key]?.toString(),
    }));
  };
  const reshaped = reshape(data);
  const [isOpen, setIsOpen] = React.useState(false);
  const [onlyDiff, setOnlyDiff] = React.useState(false);
  const onClick = () => {
    setIsOpen(true);
  };
  const onClickCancel = () => setIsOpen(false);
  return (
    <>
      <div className={styles.onTrHover}>
        <Button
          color="primary"
          variant="outlined"
          title='Просмотр описания'
          onClick={onClick}
          size='small'
          style={{ fontSize: '0.75em', padding: '4px 12px' }}
        >
          Просмотр описания
        </Button>
      </div>
      <Modal
        open={isOpen}
        onClose={onClickCancel}
        header={ "Просмотр описания" }
        width={1200}
      >
        <Grid container spacing={2}>
          <Grid style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} item xs={12}>
            <Typography>Идентификатор события: {data.data.id}</Typography>
            <FormControlLabel
                control={
                  <Checkbox checked={onlyDiff} onChange={(e) => setOnlyDiff(e.target.checked)} />
                }
                label='Только различия'
            />
          </Grid>
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Поле</TableCell>
                  <TableCell>Старое значение</TableCell>
                  <TableCell>Новое значение</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  reshaped.filter((row) => row.oldData !== row.newData || !onlyDiff).map((row) =>
                    (<TableRow key={row.key} sx={{'&:last-child td': {border: 0}}}>
                      <TableCell>{row.key}</TableCell>
                      <TableCell>{row.oldData ?? ''}</TableCell>
                      <TableCell>{row.newData ?? ''}</TableCell>
                    </TableRow>)
                  )
                }
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </Modal>
    </>
  );
}

export default ViewDetailsButton;
